import { render, staticRenderFns } from "./RenameOpportunityDialog.vue?vue&type=template&id=631dc532"
import script from "./RenameOpportunityDialog.vue?vue&type=script&lang=js"
export * from "./RenameOpportunityDialog.vue?vue&type=script&lang=js"
import style0 from "./RenameOpportunityDialog.vue?vue&type=style&index=0&id=631dc532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports